var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEquiptmentSuccessicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 67,
    viewBox: "0 0 82 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 31.5,
    r: 31.5,
    fill: "#D0FFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0623 28L48.5318 36.5304L44 31.7079",
    stroke: "#00DEA3",
    strokeWidth: 2.54206,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3133 61.3383H42.9845L42.9841 37.9596C42.9841 36.328 41.6565 35 40.0245 35H6.84955C5.21795 35 3.88995 36.3276 3.88995 37.9596V61.3383H1.56109C1.25081 61.3383 1 61.5891 1 61.8994V63.1324C1 64.7135 2.28613 66 3.86765 66H43.0065C44.5876 66 45.8741 64.7139 45.8741 63.1324V61.8994C45.8741 61.5891 45.6232 61.3383 45.3133 61.3383ZM5.01159 37.9596C5.01159 36.9458 5.83601 36.1222 6.84904 36.1222H40.024C41.0378 36.1222 41.8614 36.9466 41.8614 37.9596V61.3383H40.1781L40.1785 38.9082C40.1785 38.5979 39.9277 38.3471 39.6174 38.3471H7.25584C6.94556 38.3471 6.69475 38.5979 6.69475 38.9082V61.3383H5.01147L5.01159 37.9596ZM39.057 61.3383H7.81624V39.4691H39.056V61.3383H39.057ZM44.7519 63.1319C44.7519 64.0944 43.969 64.8774 43.0064 64.8774L3.8666 64.8778C2.90406 64.8778 2.12111 64.0948 2.12111 63.1323V62.4605H44.7517L44.7519 63.1319Z",
    fill: "#212121",
    stroke: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7173 64.1925H27.1555C27.4657 64.1925 27.7165 63.9417 27.7165 63.6314C27.7165 63.3211 27.4657 63.0703 27.1555 63.0703H19.7173C19.4071 63.0703 19.1562 63.3211 19.1562 63.6314C19.1566 63.9417 19.4074 64.1925 19.7173 64.1925Z",
    fill: "#212121",
    stroke: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquiptmentSuccessicon);
export default __webpack_public_path__ + "static/media/equiptment-success.icon.231838bb0d7d34a692b5120a28700de9.svg";
export { ForwardRef as ReactComponent };